import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import DowngradeContractForm from './DowngradeContractForm';
import DowngradeContractFormService from '../services/DowngradeContractFormService';
import { toJS } from 'mobx';

class DowngradeContractFormContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.contractId) {
      DowngradeContractFormService.init(this.props.contractId);
    }
  }

  render() {
    return (
      <DowngradeContractForm
        onReset={DowngradeContractFormService.form.reset}
        onChange={DowngradeContractFormService.form.setValue}
        contractType={toJS(DowngradeContractFormService.contract.type)}
        onSubmit={DowngradeContractFormService.handleDowngrade}
        values={DowngradeContractFormService.form.getValues()}
        disabled={DowngradeContractFormService.fetch.fetching || DowngradeContractFormService.submit.fetching}
        loading={DowngradeContractFormService.fetch.fetching}
        submitting={DowngradeContractFormService.submit.fetching}
        errors={DowngradeContractFormService.form.errors}
        onAddProduct={DowngradeContractFormService.productsService.handleToggleModal}
      />
    );
  }
}

export default observer(DowngradeContractFormContainer);
